import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import StyledFooter from "../../styles/StyledFooter";

library.add(fab, faEnvelope);

function footer(props = {}) {
  return (
    <StyledFooter>
      <div>
        <p>
          <a
            href="mailto:darrelltzj@gmail.com?subject=Ask%20Darrell%20About: &body=Hi Darrell,"
            target="_top"
            style={{ color: "black", fontSize: "1.8em" }}
          >
            <FontAwesomeIcon icon="envelope" />
          </a>{" "}
          <a
            href="https://www.linkedin.com/in/darrelltzj/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", fontSize: "1.8em" }}
          >
            <FontAwesomeIcon icon={["fab", "linkedin"]} />
          </a>{" "}
          <a
            href="https://github.com/darrelltzj"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", fontSize: "1.8em" }}
          >
            <FontAwesomeIcon icon={["fab", "github"]} />
          </a>
        </p>
      </div>
      <div>
        <p className="copyright">© {moment().local().year()} Darrell</p>
      </div>
    </StyledFooter>
  );
}

export default footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js